var panState = {};
var zoomState = {};

const scriptGraphService = {

    setZoom: function (scriptId: string, zoom) {
        zoomState[scriptId] = zoom;
    },

    setPan: function (scriptId: string, pan) {
        panState[scriptId] = pan;
    },

    getZoom: function (scriptId: string) {
        return zoomState[scriptId];
    },

    getPan: function (scriptId: string) {
        return panState[scriptId];
    },

    removeState: function (scriptId: string) {
        delete panState[scriptId];
        delete zoomState[scriptId];
    },

};
export default scriptGraphService;